import Swiper, { EffectFade, Navigation } from 'swiper';

function achievementsChoicer() {
  const entity = document.querySelectorAll('.js-achievements-choicer');
  if (!entity) return;

  const sliders = [];

  entity.forEach((elem) => {
    const nextButton = elem.querySelector('.swiper-button-next');
    const prevButton = elem.querySelector('.swiper-button-prev');
    const swiper = new Swiper(elem, {
      modules: [EffectFade, Navigation],
      speed: 600,
      effect: 'fade',
      init: true,
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });

    return sliders.push(swiper) // eslint-disable-line
  });

  return { // eslint-disable-line
    sliders,
  };
}

export default achievementsChoicer;
